module.exports = __webpack_public_path__ + "static/State-Auto-46570bd11502ce71f677a5da8746dae6.jpg";